@use '@design/design-tokens/border-radius/border-radius' as *;

.followThemeButton {
  @include border-radius-r2;
  color: var(--text-default);
  border-color: var(--border-default);

  svg {
    fill: var(--icon-default);
  }

  &.active {
    color: var(--text-success);
    border-color: var(--border-success);

    svg {
      fill: var(--icon-success);
    }
  }
}
